import React from "react";

// Signature Lotus mark — layered petals, drawn in brand pink + green.
export const LotusMark = ({ className = "", size = 40 }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <path d="M32 54c0-14 0-22 0-34" stroke="#53C653" strokeWidth="2.4" strokeLinecap="round" />
    <path
      d="M32 52C32 40 26 30 32 14c6 16 0 26 0 38Z"
      stroke="#F56FB4"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <path
      d="M32 52C24 44 14 42 12 28c14 4 18 12 20 24Z"
      stroke="#F56FB4"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <path
      d="M32 52C40 44 50 42 52 28c-14 4-18 12-20 24Z"
      stroke="#F56FB4"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <path
      d="M32 52C22 50 8 52 4 42c14-4 24 0 28 10Z"
      stroke="#53C653"
      strokeWidth="2.4"
      strokeLinejoin="round"
      opacity="0.9"
    />
    <path
      d="M32 52C42 50 56 52 60 42c-14-4-24 0-28 10Z"
      stroke="#53C653"
      strokeWidth="2.4"
      strokeLinejoin="round"
      opacity="0.9"
    />
  </svg>
);

export default LotusMark;
